import React from 'react';
import { Link } from 'react-router-dom';

export default function GoogleMyBusiness() {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url('/images/services/google-my-business-detail.jpg')` }}
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Google My Business</h1>
            <p className="text-xl mb-8">
              Boost your local presence and attract nearby customers with optimized Google Business Profile.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-zolo-orange hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold mb-6">Dominate Local Search Results</h2>
            
            <p className="text-lg text-gray-700 mb-6">
              At Zolo Service, we help businesses in Chhindwara and across India maximize their local online presence through Google Business Profile (formerly Google My Business). Our expert optimization ensures your business appears prominently in local searches, Google Maps, and the Knowledge Panel, driving more foot traffic and local customers to your business.
            </p>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Google My Business Services Include:</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Profile Setup & Verification</h4>
                  <p className="text-gray-700">
                    Complete setup, optimization, and verification of your Google Business Profile to establish credibility.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Information Optimization</h4>
                  <p className="text-gray-700">
                    Strategic optimization of business details, categories, attributes, and service areas for maximum visibility.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Photo & Video Management</h4>
                  <p className="text-gray-700">
                    Regular updates with high-quality photos and videos that showcase your business effectively.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Review Management</h4>
                  <p className="text-gray-700">
                    Monitoring, responding to, and generating positive customer reviews to build trust and credibility.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Google Posts</h4>
                  <p className="text-gray-700">
                    Regular updates with offers, events, and news to keep your profile active and engaging.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Q&A Monitoring</h4>
                  <p className="text-gray-700">
                    Proactive management of the Q&A section to provide accurate information and prevent misinformation.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Benefits of Google My Business Optimization</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Improved Local Visibility</h4>
                  <p className="text-gray-700">
                    Appear prominently in local search results and Google Maps when nearby customers search for your services.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Increased Foot Traffic</h4>
                  <p className="text-gray-700">
                    Drive more physical visits to your store or office location through improved local discovery.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Free Advertising</h4>
                  <p className="text-gray-700">
                    Gain prominent visibility in search results without paying for ads, effectively getting free advertising.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Enhanced Credibility</h4>
                  <p className="text-gray-700">
                    Build trust with potential customers through verified information, photos, and positive reviews.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Performance Insights</h4>
                  <p className="text-gray-700">
                    Gain valuable data on how customers find and interact with your business to inform marketing decisions.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center text-zolo-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </div>
                  <h4 className="font-bold text-lg mb-2">Direct Communication</h4>
                  <p className="text-gray-700">
                    Engage directly with customers through messaging, posts, and review responses to build relationships.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Google My Business Management Approach</h3>
              
              <ul className="space-y-4 text-lg text-gray-700">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Comprehensive Audit:</strong> We analyze your current Google Business Profile and identify opportunities for improvement.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Keyword Optimization:</strong> We incorporate relevant local keywords to improve your visibility in search results.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Regular Updates:</strong> We keep your profile fresh with new photos, posts, and offers to maintain engagement.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Proactive Review Management:</strong> We monitor and respond to reviews promptly to maintain a positive online reputation.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Competitor Analysis:</strong> We monitor your competitors' profiles to identify opportunities and stay ahead.</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden sticky top-24">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Boost Your Local Presence</h3>
                <p className="mb-0">Contact us today for a free Google My Business audit and consultation.</p>
              </div>
              
              <div className="p-6">
                <form className="space-y-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Email"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Phone</label>
                    <input 
                      type="tel" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Phone"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Business Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Business Name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Message</label>
                    <textarea 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      rows={4}
                      placeholder="Tell us about your Google My Business needs"
                    ></textarea>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="w-full bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-md transition duration-300"
                  >
                    Get a Free GMB Audit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
